import React from "react";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import styles from "./styles";

const RightPannel = ({
  componentToPassDown,
  open = false,
  onClose = () => {},
}) => {
  return open ? (
    <div
      data-testid={tID("RightPannel-div-Main")}
      style={styles.rightPannel}
      onClick={onClose}
    >
      <div
        data-testid={tID("RightPannel-div-Modal")}
        style={
          open
            ? {
                ...styles.sidebarMenu,
                ...styles.open,
              }
            : { ...styles.sidebarMenu }
        }
        onClick={(event) => event.stopPropagation()}
      >
        {componentToPassDown}
      </div>
    </div>
  ) : null;
};

export default RightPannel;
